import React, { useState, useEffect } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { withStyles } from '@material-ui/core';

import Dashboard from '../../../../../../layouts/Dashboard';
import CreateLocationStaff from '../../../../../../components/Global/LocationStaff/Create';

import { createLocationUserInitQuery, Location } from './queries';

import styles from './styles';
interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
  location_id: string;
}

const AdminCreateLocationStaff = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id, location_id } = useParams<UrlParams>();

  const [location, setLocation] = useState<Location>({
    name: '',
    organisation: {
      name: '',
    },
    users: [],
  });

  const { data: locationUserInitData } = useQuery(createLocationUserInitQuery(location_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && locationUserInitData) {
      setLocation(locationUserInitData.locations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [locationUserInitData]);

  const handleFinish = (id: string) => {
    history.push(`/admin/organisations/${organisation_id}/locations/${location_id}/staff/${id}`);
  };

  return (
    <>
      <Dashboard
        breadcrumbs={[
          { label: 'Organisations', link: '/admin/organisations' },
          { label: location.organisation.name, link: `/admin/organisations/${organisation_id}` },
          { label: 'Locations', link: `/admin/organisations/${organisation_id}/locations` },
          { label: location.name, link: `/admin/organisations/${organisation_id}/locations/${location_id}` },
          { label: 'Staff', link: `/admin/organisations/${organisation_id}/locations/${location_id}/staff` },
          { label: 'Create' },
        ]}>
        <CreateLocationStaff
          organisation_id={organisation_id}
          location_id={location_id}
          usedPins={location.users.filter((i) => i.pin).map((i) => i.pin)}
          handleFinish={handleFinish}
        />
      </Dashboard>
    </>
  );
};

export default withRouter(withStyles(styles)(AdminCreateLocationStaff));
